import UserInputs from "../../../components/UserInputs";
import Alert, { AlertType } from "../../../components/Alert";
import SelectPackages, { SelectPackagesMode } from "../../../components/packages/SelectPackages";

const ResellerDetails = ({ userFirstName, userLastName, userEmail, selectedPackages, availablePackages, onChangeInput, title }) => {
	return (
		<div>
			{(!title.startsWith("Edit")) &&
				<Alert type={AlertType.Warning}>
					Please add the primary contact for your new reseller. You should confirm with them which email to use. If they already have an account in the Admin
					Portal they will be asked to confirm you as their supplier - otherwise they will invited to create an account.
				</Alert>}
			<UserInputs
				nameLabel="Primary Contact"
				firstName={userFirstName}
				lastName={userLastName}
				emailLabel="Primary Contact Email"
				email={userEmail}
				onChangeInput={onChangeInput}
			/>
			<div>
				<SelectPackages packageData={availablePackages} selectedPackages={selectedPackages} onChangeInput={onChangeInput} mode={SelectPackagesMode.Reseller} />
			</div>
		</div>
	);
};

export default ResellerDetails;